import { environment } from '@env/environment';

export function inLocal(): boolean {
    return environment.name === 'local';
}
